import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {DialogComponent} from "../../../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../../../ng2-bootstrap-modal/dialog.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbValidators} from "../../../../validators/DbValidators";
import {CreateWebsiteHelpersService} from "../../../../../services/local/create-website-helpers.service";
import {OptionRegion} from "../../../../models/option-region.model";
import * as fromStore from "../../../../../store";
import {filter, first, switchMap} from "rxjs/operators";
import {combineLatest} from "rxjs";
import {Store} from "@ngrx/store";
import {Config} from "../../../../../config/config";
import {
  MigrationProgressDialogComponent
} from "./components/migration-progress-dialog/migration-progress-dialog.component";
import {HostingService} from "../../../../../websites/website/hosting/hosting.service";
import {AwsUploadService} from "../../../../services/aws-upload/aws-upload.service";
import {ActivatedRoute} from "@angular/router";
import {IAwsKeys} from "../../../../services/aws-upload/aws-keys.interface";
import {Utils} from "../../../../utils/utils";
import {GoogleAnalyticsService} from "../../../../services/google-analytics/google-analytics.service";
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";

@Component({
    selector: 'db-manual-migration-dialog',
    templateUrl: './manual-migration-dialog.component.html',
    styleUrls: ['./manual-migration-dialog.component.scss'],
    standalone: false
})
export class ManualMigrationDialogComponent extends DialogComponent<any, any> implements OnInit {
  migrateWebsiteForm = new FormGroup({
    subdomain: new FormControl('', [DbValidators.trim, Validators.required, Validators.pattern('^([a-z0-9]+(-[a-z0-9]+)*)$')]),
    region: new FormControl(null, Validators.required),
  });
  formSubmitted = false;
  loading = true;
  regions: OptionRegion[] = [];
  configHostname = Config.hostname;
  step = 1;
  isMobile = window.innerWidth <= 991;
  userSubscription: UserSubscription;
  UserSubscriptionCategory = UserSubscriptionCategory;
  @Input() ErrMessage;


  constructor(
    private _dialogService: DialogService,
    private _createWebsiteHelpersService: CreateWebsiteHelpersService,
    private _store: Store<fromStore.DbStoreState>,
    private _cdr: ChangeDetectorRef,
    private _hostingService: HostingService,
    private _awsUploadService: AwsUploadService,
    private _route: ActivatedRoute,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this._getInitialSubscriptions();
    this._awsUploadService.resetProps();
  }

  public submit(): void {
    this.formSubmitted = true;
    if (this.migrateWebsiteForm.invalid) return;
    this.loading = true;
    this._createWebsiteHelpersService.checkSubDomain(this.migrateWebsiteForm.value.subdomain)
      .then(response => {
        if (response.success) {
          this.step = 2;
        } else {
          this.migrateWebsiteForm.get('subdomain').setErrors({taken: response.message});
          this.loading = false;
        }
      });
  }

  private _getInitialSubscriptions(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
        )),
        first()
      )
      .subscribe(([user, userSubscription]) => {
        this.userSubscription = userSubscription;
        this._getInitialData(user.subscriptionId);
      });
  }

  private _getInitialData(subscriptionId): void {
    this._createWebsiteHelpersService.getWebsiteCreationInitialData(subscriptionId)
      .then(([suggestedSubDomain, regions]) => {
        this.migrateWebsiteForm.get('subdomain').setValue(suggestedSubDomain);
        const vpsRegion = {label: this.userSubscription?.plan?.dedicatedVMInfo?.zoneName, value: this.userSubscription?.plan?.dedicatedVMInfo?.vmZone,
          isAvailable: true}
        this.regions = this.userSubscription?.isDedicatedVM ? [vpsRegion] : regions;
        const region = this.regions.find(_region => _region.isAvailable);
        this.migrateWebsiteForm.get('region').patchValue(region.value);
        this._cdr.markForCheck();
        this.loading = false;
      });
  }

  startLoading(file: File) {
    this._getAWSKeys(file);
  }

  private _getAWSKeys(file) {
    this._hostingService.getAWSKeys()
      .subscribe((value) => {
        if (value && value.success) {
          const awsKeys: IAwsKeys = value.data;
          this._awsUploadService.uploadFile
          (awsKeys,
            file,
            this.migrate.bind(this, awsKeys.file_path, Utils.getExtension(file.name)),
            () => {
            });
          this._dialogService.removeAll();
          this._dialogService.addDialog(MigrationProgressDialogComponent);
        }
      });
  }

  private migrate(filePath, extension: string) {
    this._hostingService.manualMigration(this.migrateWebsiteForm.value, filePath, extension)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this._dialogService.removeAll();
          this._awsUploadService.resetProps();
          // this.migrationProcess = true;
        } else {
          // this.showManualMigrationModal(true);
          this._awsUploadService.uploadFailed.next(true);
        }
      });
  }

}
